import * as THREE from 'three'
import { useFrame } from '@react-three/fiber'
import { useAppStore } from 'startup/appStore'
import { useShallow } from 'zustand/react/shallow'

export default function useHunt(animalName, actionName, otherAnimalName, actions) {

    const { 
        gameStatus,
        player,
        currentPosition,
        otherAnimalLastPosition,
        setPositions,
        setRotation,
        effectiveTimeScale,
    } = useAppStore( useShallow((state) => ({
        gameStatus: state.gameStatus,
        player: state.player,
        currentPosition: state.positions[animalName]?.current,
        otherAnimalLastPosition: state.positions[otherAnimalName].last,
        setPositions: state.setPositions,
        setRotation: state.setRotation,
        effectiveTimeScale: state.effectiveTimeScales[animalName],
    })));

    const direction = new THREE.Vector3();
    const rotation = new THREE.Euler(0, 0, 0, 'YXZ');
    const currentPositionClone = currentPosition.clone();

    const distance = new Array(3);
    let xOrZ, xOrZValue;

    useFrame((state, delta) => {
        if (gameStatus === 'start' && player === otherAnimalName) {

            distance[0] = otherAnimalLastPosition.x - currentPosition.x;
            distance[2] = otherAnimalLastPosition.z - currentPosition.z;
            xOrZ = Math.abs(distance[0]) >= Math.abs(distance[2]) ? 0 : 2;
            xOrZValue = distance[xOrZ];

            direction.setComponent(xOrZ, 1 * Math.sign(xOrZValue));

            currentPositionClone.setComponent(
                xOrZ,
                currentPosition.getComponent(xOrZ) +
                Math.sign(xOrZValue) * delta * effectiveTimeScale
            );

            setPositions(animalName, currentPositionClone)

            rotation.y = Math.atan2(direction.x, direction.z);
            setRotation(animalName, rotation)

            actions[actionName].
                setLoop(THREE.LoopRepeat).
                setEffectiveTimeScale(effectiveTimeScale).
                play();
        }
    });
};


